let speakerJson = require('../data/speaker.json');

document.addEventListener("DOMContentLoaded", function(event) { 
    generatespeakerData();

});

window.onload = () => {
    handlePageLoaded();
};

function handlePageLoaded(){
    document.getElementsByClassName("loading-screen")[0].style.display = "none";
    document.getElementById("section-meetthespeakers").style.display = "block";
}

async function generatespeakerData() {

    let workshopContainer = document.querySelector("#workshopspeaker-cards");
    let forumContainer = document.querySelector("#forumspeaker-cards");

    speakerJson.forEach(speaker => {

        if (speaker.type == "workshop") {
            workshopContainer.innerHTML += `
            <div class="card speaker-card p-2" style="max-width: 800px;" >
                <div class="row g-0">
                    <div class="col-md-4 m-0 d-flex justify-content-center align-items-center">
                      <img src="${speaker.image}" class="img-fluid speaker-image" alt="Photo of speaker ${speaker.name}"></div>
                      <div class="col-md-8">
                      <div class="card-body p-3 pb-2">
                          <h5 class="card-title fw-bold">${speaker.name}</h5>
                          <p class="speaker-card-text lh-sm">
                            ${speaker.bio}
                          </p>   
                          <br>
                          <div>
                              <div class="text-decoration-underline fw-bold mb-2">Session</div>
                              <div class="mb-2 d-flex align-items-center">
                                  <button class="btn rounded-circle icon-circle me-2 p-0">
                                    <i class="fa fa-${speaker.sessionIcon} speaker-icon"></i>
                                  </button>
                                  <div class="d-inline-block">${speaker.sessionName}</div>
                              </div>
                              <div class="d-flex align-items-center">
                                  <button class="btn rounded-circle icon-circle me-2 p-0">
                                    <i class="fa fa-clock speaker-icon"></i>
                                  </button>
                                  ${speaker.sessionTime}
                              </div>
                          </div>
                      </div>
    
                    </div>
                </div>
            </div>
            `

            
        } else {
            forumContainer.innerHTML += `
            <div class="card speaker-card p-3" style="max-width: 500px;" >
                <div class="row g-0">
                    <div class="col-md-4 m-0 d-flex justify-content-center align-items-center">
                      <img src="${speaker.image}" class="img-fluid speaker-image" alt="Photo of speaker ${speaker.name}"></div>
                      <div class="col-md-8">
                      <div class="card-body p-3 pb-2">
                          <h5 class="card-title fw-bold">${speaker.name}</h5>
                          <p class="speaker-card-text lh-sm">
                            ${speaker.bio}
                          </p>   
                          <br>
                      </div>
    
                    </div>
                </div>
            </div>
            `
        }

        
    })
}